<div
  class="flex flex-col items-start justify-start bg-slate-50 pl-8 pr-8 pt-16 pb-16 flex-nowrap h-fit w-full"
>
  <div class="flex flex-col m-auto items-center justify-center flex-nowrap h-fit w-full gap-6">
    <span class="text-slate-500 text-sm font-medium tracking-normal leading-5 text-left">{{
      copyrightText()
    }}</span>
  </div>
</div>
